import { render, staticRenderFns } from "./IndexS.vue?vue&type=template&id=cfd804de&scoped=true&"
import script from "./IndexS.vue?vue&type=script&lang=js&"
export * from "./IndexS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd804de",
  null
  
)

export default component.exports